const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/

const forbiddenDomains = [
  'gmail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'live.com',
  'orange.fr',
  'free.fr',
  'sfr.fr'
]

export const sanitizeDomain = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .replace(/^www\./, '')
    .replace(/[/?#:].*$/, '')

export const isValidDomain = (value: string): boolean => {
  const domain = sanitizeDomain(value)
  if (!domain) return false

  const isForbidden = forbiddenDomains.some((d) => domain === d || domain.endsWith(`.${d}`))

  return domainRegex.test(domain) && !isForbidden
}
